import { mountUsageRuntime } from '../services/usageRuntime';
import { legacyUsageState, legacyUsagePanels } from './legacyUsageState';
import { observeLegacyFrames } from './legacyUsageFrames';

export default {
  beforeCreate() { this._usageExtra = {}; this._usagePanels = {}; },
  provide() {
    return { chartUsage: {
      state: (key, value) => { this._usageExtra[key] = value; if (this._usageRuntime) this._usageRuntime.refresh(); },
      panel: (surface, tool) => { this._usagePanels[surface] = tool; if (this._usageRuntime) this._usageRuntime.refresh(); },
      track: (...args) => { if (this._usageRuntime) this._usageRuntime.track(...args); }
    } };
  },
  mounted() {
    let previousUid = Number(this.$store.state.user_id);
    const start = () => {
      if (this._usageRuntime) this._usageRuntime.stop({ discard: true });
      if (this._usageFrames) this._usageFrames();
      this._usageRuntime = null;
      const uid = Number(this.$store.state.user_id);
      if (uid !== previousUid) { this._usageExtra = {}; this._usagePanels = {}; previousUid = uid; }
      if (!uid || this.is_streaming !== false) return;
      try {
        this._usageRuntime = mountUsageRuntime({ uid, experience: 'classic', root: () => this.$el,
          readState: () => ({ ...legacyUsageState(this), ...this._usageExtra }),
          readPanels: () => ({ ...legacyUsagePanels(this), ...this._usagePanels }),
          onReady: () => { this._usageFrames = observeLegacyFrames(() => this.$el, this._usageRuntime); }
        });
      } catch (_) { /* Unsupported browsers continue without profiling. */ }
    };
    this._usageIdentityWatch = this.$watch(() => `${this.$store.state.user_id}:${this.is_streaming}`, start, { immediate: true });
    // Watch only compact, explicitly selected state; never the full store/stock universe.
    this._usageStateWatch = this.$watch(() => JSON.stringify([legacyUsageState(this), legacyUsagePanels(this)]), () => {
      if (this._usageRuntime) this._usageRuntime.refresh();
    });
  },
  beforeDestroy() {
    if (this._usageIdentityWatch) this._usageIdentityWatch();
    if (this._usageStateWatch) this._usageStateWatch();
    if (this._usageFrames) this._usageFrames();
    if (this._usageRuntime) this._usageRuntime.stop();
  }
};
